// extracted by mini-css-extract-plugin
module.exports = {"block":"block___1h1fk","btn":"btn___36C-E"};